module.exports = __webpack_public_path__ + "static/media/outdoor_01_A.18aea034.png";